import { filter } from 'rxjs/operators';
import { Configuration } from "src/app/shared/configuration";
import {
  Component,
  ViewChild,
  Renderer2,

} from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { FnolService } from "./../features/fnol/services/fnol.service";
import { FNOL_COUNTRY, TITLEMAINCONTENT } from "../features/fnol/config/fnol-constants";
import { CacheService } from "../shared/services/cache.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: "cdp-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {

titleContent = TITLEMAINCONTENT();
  augRefresh = {};
  axisNavPanelClosed: boolean;
  navbarOpen: boolean;
  appAccountId: number = 1;
  appPanel: string;
  appPanelHighlighted: string;
  appRouteHome: string = "/index";
  appStep: number;
  appUserId: number = 1;
  uiStructure;
  uiData;
  tempUIStructure;
  public prevSelectedCountry = [];
  countryMenu = {
    align: 'right',
    assets: 'assets/images/cca2-flags-round/',
    closeOnLeave: true,
    closeOnOutsideClick: false,
    columns: 1,
    filter: this.configService.countryCodesArray,//['AU', 'CA', 'HK', 'IE', 'MY', 'NZ', 'SG', 'ZA','ES','GB','US'], // CA and PR provide multiple languages
    // filter: ['Africa', 'Americas', 'Asia Pacific', 'Europe', 'Middle East'],
    filterBy: 'country', // 'country', 'none', 'region',
    flyout: false, // false = only show top-level list
    heading: '',
    headingType: 'country',
    headingIcon: { font: 'custom', icon: 'world', size: 'medium', color: '' },
    id: 'menuCountryLanguageRound', // unique to this dropdown
    label: 'Country Language Selection',
    languageCode: false, // true: show language code, set to uppercase
    menuVisible: false,
    outline: 'none', // 'none': no border on menu button
    preselect: 'AU',
    textSize: 'large',
    selected: { cca2: '', name: '', native: '', src: '', value: '' }, // readonly object
    showOnHover: true,
    showSelected: true,
    templateClasses: 'axis-navbar-dropdown',
    wrap: false, // false: don't wrap menu item text
    items: [],
  };

  axisNavbar: boolean = false;
  axisNavNotifications: boolean = true;
  axisNavUserName: boolean = true;

  axisNotification: any = {
    dismissible: true,
    fadeout: true,
    kind: "success",
    message: "See copydeck for text.",
    timeout: 2000,
    visible: false,
  };
  //#region class properties declarations
  bodyTheme: string;
  dev: boolean = true;
  sub: any;
  subc: any;
  titlePage: string = "Document Title";
  titleProject: string = " :: Claims Digital Portal";
  step;
  Object;
  selectedLanguage: string | null;
  screenSize = 'desktop';
  readonly FNOL_COUNTRY = FNOL_COUNTRY;
  fnolCheck = true;
  selectedItem = "myClaim";
  languages: string | undefined | null;
  country: string | undefined | null;
  @ViewChild("axisNotificationVar") axisNotificationVar;
  public axisNavbarRight: boolean = false;
  public claimDashboard: boolean = false;
  public circlePerson: boolean = true;
  public noNavBar: boolean = false;
  public axisNavbarRightPassword: boolean = false;
  public uaFormBooleanEx: FormGroup;
  language = localStorage.getItem("language");
  subList: any;
  cdpOrFnol = '';
  partialRouterLink = '';
  showHeader: boolean = false;
  getCountryCode: any;
  SubjectStatus: any;
  title: any;
  private subscription: Subscription[] = [];
  //#endregion
  constructor(
    private renderer: Renderer2,
    private cacheService: CacheService,
    public router: Router,
    private fb: FormBuilder,
    public fnolService: FnolService,
    public breakpointObserver: BreakpointObserver,
    private http: HttpClient,
    private configService: Configuration,
    private route: ActivatedRoute,
  ) {
    this.languages = window.location.pathname.split("/")[4];
    this.country = localStorage.getItem("country")?.toLowerCase();
    if (window.location.href.indexOf("/fnol") > 0) {
      this.fnolCheck = true;
      this.selectedLanguage = "jp";
    } else {
      this.fnolCheck = false;
    }
    this.uaFormBooleanEx = this.fb.group({
      booleanControl: this.cacheService.get("language") || "en",
    });
    const sub1 = this.breakpointObserver
      .observe(['(max-width: 767px)'])
      .subscribe((state: BreakpointState) => {
        this.screenSizeRender(state);
      });
    this.subscription.push(sub1);
  }



  screenSizeRender(stateVal) {
    if (Object.values(stateVal.breakpoints)[0]) {
      this.screenSize = 'mobile';
    } else {
      this.screenSize = 'desktop';
    }

    this.renderer.setAttribute(
      document.documentElement,
      'data-screensize',
      this.screenSize
    );
  }

  loadData() {
    setTimeout(() => {
      this.uiStructure = this.tempUIStructure;

    }, 50);
  }

  ngOnInit(): void {

    this.http
      .get("assets/data/locale/en-lite/fnol-claim-overview.json")
      .subscribe((res1) => {
        const res = res1 as any;
        this.tempUIStructure = res.uiStructure;
        //  this.tempUIData = res.uiData;
        this.uiStructure = this.tempUIStructure
        this.loadData();
      })

    this.fnolService.saveCounter = false;
    this.getCountryCode = window.location.pathname.includes('nordics') ? window.location.pathname.split("/")[3] : window.location.pathname.split('/')[2]
    //window.location.pathname.split('/')[2]
    if (this.getCountryCode) {
      this.countryMenu.preselect = this.getCountryCode.toUpperCase();
    }
    console.log(this.countryMenu)

    this.fnolService.pageDetail.subscribe((res) => {
      this.step = res["step"];
    });
    if (this.languages === 'no') {
      this.title = 'Skademelding';
    } else {
      this.title = 'Claims Digital Portal';
    }

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe(); // with url query
    this.subc.unsubscribe();
  }
  toggleNavbar(): void {
    this.navbarOpen = !this.navbarOpen;
    if (this.navbarOpen) {
      this.renderer.addClass(document.body, 'axis-navbar-mobile-open');
    }
    else {
      this.renderer.removeClass(document.body, 'axis-navbar-mobile-open');
    }
  }
  /* methods */
  closeOverlay(): void {
    this.navbarOpen = false;
    this.renderer.removeClass(document.body, 'axis-navbar-mobile-open');
  }

  // sidebar UI behaviors
  languageChange(e): void {
    const urlParams = new URLSearchParams(window.location.search);
    if (e && e !== (urlParams.get("language") as string).toLowerCase()) {
      window.open(
        `/fnol?country=${urlParams.get("country")}&policyNo=${urlParams.get(
          "policyNo"
        )}&language=${e}&lob=${urlParams.get("lob")}&partner=gojek`,
        "_self"
      );
      setTimeout(() => {
        this.selectedLanguage = urlParams.get("language");
      });
    }
  }


  selectionchanged($event) {
    this.countryMenu.selected = $event
    this.fnolService.editCountry(this.countryMenu.selected.cca2.toLocaleLowerCase());
  }

}
